import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import { Token_Generator, signup, getIndustry } from "../../actions/auth";
import { logo, eyeSeen, eyeUnseen, eyeSeenFocus, eyeUnseenFocus } from "../../Image/Index";
import TextValidator from "../partial/TextValidator";
import SelectValidator from "../partial/SelectValidator";
import PasswordValidator from "../partial/PasswordValidator";
import axios from "../../utils/axios";
import swal from "sweetalert";

import ReCAPTCHA from "react-google-recaptcha";

const SignUp = () => {
    const formRef = useRef();
    const [isRevealPassword, setIsRevealPassword] = useState(false);
    const [isConfirmPassword, setIsConfirmPassword] = useState(false);
    // const [passwordLabel, setPasswordLabel] = useState();
    const [passwordFocus, setPasswordFocus] = useState(false);
    const [confirmFocus, setConfirmFocus] = useState(false);
    const navigate = useNavigate();
    // const [formData, setFormData] = useState({
    //     Name: "",
    //     emailID: "",
    //     contactNumber: "",
    //     newPassword: "",
    //     confirmPassword: "",
    //     selectedTypeId: "",
    //     companyName: "",
    //     detailAboutProject: "",
    //     tAndC: false,
    //     error: false,
    //     options: [],
    //     needSelectedTypeId: "",
    //     needOptions: [
    //         {
    //             value: "Launch a new loyalty program",
    //             label: "Launch a new loyalty program",
    //         },
    //         {
    //             value: "Replace existing loyalty program",
    //             label: "Replace existing loyalty program",
    //         },
    //         {
    //             value: "Need more information on loyalty setup",
    //             label: "Need more information on loyalty setup",
    //         },
    //     ],
    // });
    const [formData, setFormData] = useState({
        id: 0,
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  createdAt: "",
  creditBalance: 0,
  lastOtp: 0,
  isActive: 0,
  mobileNumber: "",
  userId: ""
    });
    const [finalData, setFinalData] = useState({});
    const [loader, setLoader] = useState(false);
    const invalidDomains = ["mailinator", "cwmxc", "horsgit", "maildrop", "explodemail", "stresspc", "anonaddy"];

    const { firstName, lastName, email, password, mobileNumber, newPassword } = formData;
    const onChange = (e) => setFormData({ ...formData, ...{ [e.target.name]: e.target.value } });

    useEffect(() => {
        ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
            if (value !== password) {
                return false;
            }
            return true;
        });
        // eslint-disable-next-line
    }, [password, newPassword]);

    useEffect(() => {
        const validateEmail = (email) => {
            const domainPattern = invalidDomains.join("|");
            const regexPattern = `^(?!.*@(${domainPattern})\\b)([a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`;

            const regex = new RegExp(regexPattern);
            if (regex.test(email)) {
                return true;
            } else {
                return false;
            }
            // return email.match(/^(?!.*@(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        };
        ValidatorForm.addValidationRule("validEmail", (value) => {
            if (validateEmail(value)) {
                return true;
            }
            return false;
        });
    }, [email]);

    useEffect(() => {
        const validateName = (name) => {
            return /^[A-Za-z\s]*$/.test(name);
        };
        ValidatorForm.addValidationRule("validName", (value) => {
            if (validateName(value)) {
                return true;
            }
            return false;
        });
    }, [firstName,lastName]);


 




    const onSelectChange = (e) => setFormData({ ...formData, selectedTypeId: { ...e } });
    const onNeedSelectChange = (e) => setFormData({ ...formData, needSelectedTypeId: { ...e } });

    const handleCheckbox = (e) => setFormData({ ...formData, tAndC: e.target.checked });
  

    const onSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== password) {
            swal({
                title: " Oops!",
                text: "Please match new password and confirm password",
                icon: "warning",
                button: "oh no!",
                timer: 5000,
            });
        } else {
         
                if (newPassword !== password) {
                    setFormData({ ...formData, error: true });
                }
                {
                    setLoader(true);
                    const response = await signup(formData);
                    if (response.message === "Sucess") {
                        setLoader(false);
                        console.log(response?.data.item1?.userId)
                        navigate("/otp-verification", { state: { userID: response?.data.item1?.userId } });
                    } else if (response.message === "Already Created") {
                        setLoader(false);
                        swal({
                            title: " Oops!",
                            text: "Your Account Already Registered, Please forget your password",
                            icon: "warning",
                            button: "oh no!",
                            timer: 5000,
                        });

                        setLoader(false);
                    } else {
                        swal({
                            title: " Oops!",
                            text: " Something went wrong please try again.",
                            icon: "error",
                            button: "oh no!",
                            timer: 5000,
                        });

                        setLoader(false);
                    }
                
            }
        }
    };

    return (
        <section className="section signUpPage">
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="signUpPage__main"style={{background:"none"}}>
            <div className="signUpPage__Boxed">
                    <div className="signUpPage__heading">
                        {/* <figure>
                            <img src={logo} alt="logo" />
                        </figure> */}
                        <h1>Sign Up</h1>
                     
                    </div>
                    <div className="signUpPage__form">
                        <ValidatorForm className="signUpPage__formSection" ref={formRef} autoComplete="off" autoCapitalize="off" onSubmit={(e) => onSubmit(e)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <TextValidator className="form-control" placeholder="First Name" name="firstName" maxLength="50" value={firstName} onChange={onChange} validators={["required", "trim", "validName"]} errorMessages={["Please enter your name", "Enter valid Name", "Enter valid Name"]} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <TextValidator className="form-control" placeholder="Last Name" name="lastName" maxLength="50" value={lastName} onChange={onChange} validators={["required", "trim", "validName"]} errorMessages={["Please enter your name", "Enter valid Name", "Enter valid Name"]} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <TextValidator className="form-control" placeholder="Email" name="email" maxLength="50" value={email} type="email" onChange={onChange} validators={["required", "validEmail"]} errorMessages={["Please enter your email", "Enter valid email"]} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <TextValidator className="form-control" placeholder="Contact Number" name="mobileNumber" maxLength="50" value={mobileNumber} onChange={onChange} validators={["required", "matchRegexp:^(?!\\d*(\\d)\\1{7,}|0123456789|1234567890)\\d{10,15}$"]} errorMessages={["Please enter your contact number", "Please enter a valid number"]} />
                                    </div>
                                </div>
                               
                                <div className="col-md-12">
                                    <div className="form-group withIcon">
                                        <span className="passwordToggle">{passwordFocus ? <img className="onFocus" title={isRevealPassword ? "Hide password" : "Show password"} src={isRevealPassword ? "/Images/eyeUnseenFocus.png" : "/Images/eyeSeenFocus.png"} alt="eye" onClick={() => setIsRevealPassword((prevState) => !prevState)} /> : <img title={isRevealPassword ? "Hide password" : "Show password"} src={isRevealPassword ? "/Images/eyeUnseen.png" : "/Images/eyeSeen.png"} alt="eye" onClick={() => setIsRevealPassword((prevState) => !prevState)} />}</span>
                                        <PasswordValidator placeholder="New Password" className="form-control" name="newPassword" minLength="6" maxLength="16" value={newPassword} type={isRevealPassword ? "text" : "password"} onChange={onChange} validators={["required", "matchRegexp:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,16}$"]} errorMessages={["Please enter password.", "condition"]} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group withIcon">
                                        <span className="passwordToggle">{confirmFocus ? <img className="onFocus" title={isConfirmPassword ? "Hide password" : "Show password"} src={isConfirmPassword ? "/Images/eyeUnseenFocus.png" : "/Images/eyeSeenFocus.png"} alt="eye" onClick={() => setIsConfirmPassword((prevState) => !prevState)} /> : <img title={isConfirmPassword ? "Hide password" : "Show password"} src={isConfirmPassword ? "/Images/eyeUnseen.png" : "/Images/eyeSeen.png"} alt="eye" onClick={() => setIsConfirmPassword((prevState) => !prevState)} />}</span>
                                        <PasswordValidator placeholder="Confirm Password" className="form-control" name="password" maxLength="16" value={password} type={isConfirmPassword ? "text" : "password"} onChange={onChange} validators={["required", "isPasswordMatch"]} errorMessages={[" Please enter confirm password.", "Password Mismatch."]} />
                                    </div>
                                </div>
                                
                              
                            
                               
                              
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-primary btn-lg w-100">
                                            Continue
                                        </button>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p>
                                            Already have an account? <Link to="/signin">Sign In</Link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SignUp;
